import { createContext, useContext, useState, useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'

const StageContext = createContext()

export const useStage = () => {
  const context = useContext(StageContext)
  if (!context) {
    throw new Error('useStage must be used within a StageProvider')
  }
  return context
}

export const StageProvider = ({ children, initialStage = 1 }) => {
  const [currentStage, setCurrentStage] = useState(initialStage)

  const goToStage = useCallback((stageNumber) => {
    if (stageNumber >= 1 && stageNumber <= 5) {
      setCurrentStage(stageNumber)
    }
  }, [])

  const resetProgress = useCallback(() => {
    setCurrentStage(1)
  }, [])

  const value = useMemo(() => ({
    currentStage,
    goToStage,
    resetProgress
  }), [currentStage, goToStage, resetProgress])

  return (
    <StageContext.Provider value={value}>
      {children}
    </StageContext.Provider>
  )
}

StageProvider.propTypes = {
  children: PropTypes.node.isRequired,
  initialStage: PropTypes.number
}

export default StageContext
